export default {
  TRIAL_ONBOARDING_MODULE_INIT_DONE: 'trial-onboarding:module:init-done',
  TRIAL_ONBOARDING_GAME_MODAL_NEXT: 'trial-onboarding:game-modal:next',
  TRIAL_ONBOARDING_MODAL_CLOSE: 'trial-onboarding:modal:close',
  TRIAL_ONBOARDING_NOTIFICATION_SUCCESS:
    'trial-onboarding:notification:success',
  TRIAL_ONBOARDING_INFO_TIMESHEET: 'trial-onboarding:info-timesheet:show',
  GAMIFICATION_TASK_TRIGGERED: 'trial-onboarding:gamification:task-triggered',
  GAMIFICATION_MARK_TASK_DONE: 'trial-onboarding:gamification:mark-task-done',
  GAMIFICATION_MARK_TASK_DONE_COMPLETED:
    'trial-onboarding:gamification:mark-task-done-completed',
  GAMIFICATION_COLLAPSE_LIST: 'trial-onboarding:gamification:collapse-list',
  GAMIFICATION_EXPAND_LIST: 'trial-onboarding:gamification:expand-list',
  GAMIFICATION_LEGACY_INIT_DONE:
    'trial-onboarding:gamification-legacy:init-done',
  TRIAL_ONBOARDING_FREEMIUM_UPGRADE: 'freemium_upgrade_modal:open',
  CHOOSE_PLAN: 'choose_plan:open',
  CHOOSE_PLAN_IN_TENANT: 'choose_plan_in_tenant:open',
  UPGRADE_TO_PAID: 'upgrade:open',
  SHOW_SUBSCRIPTION_OPTIONS: 'show_subscription_options:open',
  HIDE_SUBSCRIPTION_OPTIONS: 'hide_subscription_options:close',
  RESET_TRIAL: 'reset_trial:open',
  FLEXI_LEARN_MORE: 'flexi_learn_more:open',
  BOOK_DEMO_MORE_EMPLOYEES: 'trial-onboarding:book-demo:toggle-more-employees',
  LOCATIONS_SETUP_STEP_COMPLETE:
    'trial-onboarding:locations-setup-step:complete',
  ADD_TEAM_STEP_COMPLETE: 'trial-onboarding:add-team-step:complete',
  LOCATIONS_SETUP_SUCCESS: 'trial-onboarding:locations-setup-step:show-success',
  SETUP_WIZARD_COMPLETE: 'trial-onboarding:setup-wizard:complete',
  IMPORT_PEOPLE_VIA_INTEGRATION_COMPLETE:
    'import-people-via-integration-complete',
  GAMIFICATION_ADD_TEAM_CLOSE: 'trial-onboarding:game-add-team:close',
  HIDE_GAMIFICATION_BUBBLE: 'trial-onboarding:gamification:hide',
  SHOW_GAMIFICATION_BUBBLE: 'trial-onboarding:gamification:show',
};
